import { resetPasswordService } from '../../../../services/user-session/reset-password.service';
import { QUERY_KEYS } from '../../../../consts';
import { getAtomWithMutation } from '../../../../utils';

export const resetPasswordAtom = getAtomWithMutation({
  mutationKey: QUERY_KEYS.USER_SESSION.RESET_PASSWORD,
  mutationFn: () => resetPasswordService,
  retry: 0,
});
